// extracted by mini-css-extract-plugin
export default {"melodyVideo":"_L-z","isFullWidth":"aM-z","landingPageVideo":"bM-z","play":"cM-z","iframeVideo":"dM-z","playHidden":"eM-z","fullwidth":"fM-z"};